import { get, post } from "@/utils/http";

let baseURL = "/device";
/**
 * 获取集中器list
 */
const getConcentratorInfo = () => post(`${baseURL}/getConcentratorInfo`,'');

/**
 * 获取插座list
 */
const getSocketInfo = data => get(`${baseURL}/getSocketInfo`, data);
/**
 * 获取页面list
 */
const getPageInfo = data => post(`${baseURL}/queryInfo`, { data });

/**
 * 生成二维码
 */
const generatorQrCode = data => post(`${baseURL}/generatorQrCode`, { data });

/**
 * 新增设备
 */
const createGenerator = data => post(`${baseURL}/create`, { data });

/**
 * 编辑设备
 */
const updateGenerator = data => post(`${baseURL}/update`, { data });

/**
 * 删除设备
 */
const deleteGenerator = data => post(`${baseURL}/delete`, { data });
/**
 * 批量导出二维码
 */
const exportQrcode = data => post(`${baseURL}/exportQrcode`, { data , responseType :'blob'});
export default {
  deleteGenerator,
  updateGenerator,
  createGenerator,
  generatorQrCode,
  getPageInfo,
  getConcentratorInfo,
  getSocketInfo,
  exportQrcode
};
